var sw = require('./sw');
var url = require('url');
var _ = require('underscore');

module.exports = {
  getHref: function(fragmentName, options) {
    if (!sw.data.fragmentEndpoints || !sw.data.fragmentEndpoints[fragmentName]) {
      return false;
    }

    options = options || {};

    var fragmentData = sw.data.fragmentEndpoints[fragmentName];
    var path = options.endpoint || fragmentData.endpoint;
    var urlObj = url.parse(path, true);

    urlObj.search = null;
    urlObj.query = _.extend(urlObj.query, fragmentData, options);

    var href = url.format(urlObj);

    return href;
  }


};
